import { ColoursObj, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { generalTranslation } from "i18n/translateHelpers";
import { useScreenTypeContext } from "../../state/screenTypeProvider";

interface IDraftMessageProps {
  data?: any;
}
export const DraftMessage = ({ data }: IDraftMessageProps) => {
  const { screenType } = useScreenTypeContext();
  if (!(screenType === "edit" && data.revision_status === "draft")) {
    return null;
  }
  return (
    <Stack sx={{
      alignItems: "center"
    }}>
      <Typography color={ColoursObj.states.warning} variant="bodySubtextBold">
        {generalTranslation("Draft")}
      </Typography>
    </Stack>
  );
};
